/**
 * Calculates the delay (in ms) before the next retry attempt
 * using exponential backoff: 100ms, 200ms, 400ms, …
 *
 * @param {number} retryCount - The current retry attempt number (1-based)
 * @returns {number} Delay in milliseconds
 */
export const getRetryDelay = retryCount => {
  const base = parseInt(process.env.REACT_APP_RETRY_BASE_DELAY, 10) || 100
  return base * Math.pow(2, retryCount - 1)
}

/**
 * Determines whether a failed request should be retried.
 *
 * Retries on:
 *  - Network errors (no response)
 *  - 500 Internal Server Error
 *  - Connection aborted (ECONNABORTED)
 *  - Request timeout (ETIMEDOUT)
 *
 * @param {Error} error - The Axios error object
 * @returns {boolean}
 */
export const shouldRetry = error => {
  if (!error.response) return true // network error
  const { status } = error.response
  return (
    status === 500 ||
    error.code === "ECONNABORTED" ||
    error.code === "ETIMEDOUT"
  )
}
